import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'chaoskit/src/components';

import BaseLayout from './BaseLayout';
import { Icon } from '../components';
import StaticFooter from '../partials/footer/StaticFooter';

const ChaosMonkeyLayout = ({ children, contrast }) => {
  useEffect(() => {
    const $html = document.documentElement;

    $html.classList.add('is-chaosMonkey');

    return () => {
      $html.classList.remove('is-chaosMonkey');
    };
  }, []);

  return (
    <BaseLayout headerProps={{ contrast }} noFooter>
      {children}
      <StaticFooter />
      <Button
        noRadius
        className="button--chaosMonkey chaosMonkey__cta"
        url="/chaos-monkey-guide-pdf/"
      >
        Download PDF
        <Icon className="u-ml--small" icon="arrow-right" />
      </Button>
    </BaseLayout>
  );
};

ChaosMonkeyLayout.propTypes = {
  children: PropTypes.node.isRequired,
  contrast: PropTypes.bool,
};

ChaosMonkeyLayout.defaultProps = {
  contrast: true,
};

export default ChaosMonkeyLayout;
